import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation, useNavigate } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import { avantSolarApi } from "api/authApi";
import { useSelector } from "react-redux";
import Alert from "components/alert";
import ChangePassWordModal from "components/utils/changePassModal";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import DataTableAvantSolar from "components/datatable/datatable";
import { obtenerNombreHuertaId } from "utils/generalFunctions";
import Footer from "components/Footer/Footer";
import UploadFileModal from "components/utils/uploadFileModal";
import { convertirFechaLetra } from "utils/generalFunctions";
import { convertirFecha } from "utils/generalFunctions";
import ModifyFileModal from "components/utils/modifyFileModal";
import { log } from "util";
import { convertB64ToCSV } from "utils/generalFunctions";
import { convertirFechaInputFecha } from "utils/generalFunctions";

var ps;

function ModificarLecturas(props) {
  const mainPanel = React.useRef();
  const location = useLocation();
  const { jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [error, setError] = useState(null);
  const [fechaInput, setFechaInput] = useState(null);

  const [loading, setLoading] = useState(false);
  const [lecturas, setLecturas] = useState();
  const [lecturasCopy, setLecturasCopy] = useState();
  const [modal, setModal] = useState(false);
  const [modalInsert, setModalInsert] = useState(false);
  const [buttonsDisabled, setButtonsDisabled] = useState(true);
  const [fechaMaxInput, setFechaMaxInput] = useState(null);

  const toggleModal = () => {
    setModal(!modal);
  };
  const toggleModalInsert = () => {
    setModalInsert(!modalInsert);
  };

  useEffect(() => {
    if (lecturas?.length > 0 && lecturas[0]?.fechaUltimaLectura) {
      let fecha = lecturas[0]?.fechaUltimaLectura;

      fecha = fecha.toString();

      let dia = fecha.substring(6, 8);
      let mes = fecha.substring(4, 6);
      let anio = fecha.substring(0, 4);

      let fechaParse =
        anio +
        "-" +
        (mes.length == 1 ? "0" + mes : mes) +
        "-" +
        (dia.length == 1 ? "0" + dia : dia);

      setFechaMaxInput(fechaParse);
    }
  }, [lecturas]);

  useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  }, []);

  useEffect(() => {
    fetchLecturas();
  }, [huerta]);

  const fetchLecturas = async (fecha = "") => {
    setError(null);
    setLoading(true);

    try {
      const response = await avantSolarApi.get(
        "/admins/dataMeter?id_huerta=" + huerta + "&fecha=" + fecha,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;

      setLoading(false);
      if (data?.code == 200) {
        setLecturas([...data.data]);
        setLecturasCopy([...data.data]);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const headers = [["Instalación", "Titular", "Neta", "Export", "Import"]];
  const headersTable = [
    { name: "Instalación", prop: "numInstalacion" },
    { name: "Titular", prop: "titular" },

    { name: `Neta`, prop: "neta" },
    { name: "Export", prop: "export" },
    { name: "Import", prop: "import" },
  ];

  const properties = ["numInstalacion", "titular", "neta", "export", "import"];

  const handleSumbitForm = (event) => {
    event.preventDefault();
  };

  const downloadTemplate = async () => {
    try {
      const response = await avantSolarApi.get(
        "/admins/downloadMeterTemplate",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;

      if (data?.code == 200) {
        let archivo = data.data.archivo;
        convertB64ToCSV(
          archivo,
          "plantilla_lecturas_" + obtenerNombreHuertaId(huerta)
        );
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  const handleChangeInputFecha = (ev) => {
    setButtonsDisabled(true);
    let fecha = ev.target.value;
    if (fecha.length == 0) {
      setFechaInput(null);

      return;
    }

    fetchLecturas(fecha.replaceAll("-", ""));
    setButtonsDisabled(false);
    setFechaInput(fecha.replaceAll("-", ""));
  };

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />
          <div className="mb-3">
            <div className="d-flex justify-content-center">
              <form
                onSubmit={handleSumbitForm}
                className="d-flex flex-column flex-sm-row justify-content-center align-items-center borderModify px-4 py-2 px-sm-5 py-sm-4 mx-sm-5 mx-sm-0"
              >
                <div className="mt-2 mt-sm-0">
                  <div className="d-flex justify-content-center align-items-center mb-2">
                    <p className="mr-1">Fecha:</p>
                    <input
                      max={fechaMaxInput}
                      onChange={(ev) => {
                        handleChangeInputFecha(ev);
                      }}
                      className="ml-1"
                      type="date"
                    />
                  </div>
                  <ModifyFileModal
                    fetchLecturas={fetchLecturas}
                    fechaInput={fechaInput}
                    modal={modal}
                    toggleModal={toggleModal}
                  ></ModifyFileModal>
                  <UploadFileModal
                    fetchLecturas={fetchLecturas}
                    fechaInput={fechaInput}
                    modal={modalInsert}
                    toggleModal={toggleModalInsert}
                  ></UploadFileModal>
                  <div className="d-flex flex-column flex-sm-row">
                    <div className="d-flex">
                      <button
                        disabled={buttonsDisabled}
                        onClick={toggleModal}
                        className={`px-3 btn btn-warning w-100 border-0 text-dark py-1 rounded ml-1`}
                      >
                        {" "}
                        <span className="mdi mdi-plus-circle-outline mr-2"></span>
                        Modificar
                      </button>
                      {/* <button
                        disabled={buttonsDisabled}
                        onClick={toggleModalInsert}
                        className={`px-3 btn btn-success border-0 text-dark py-1 rounded ml-1`}
                      >
                        {" "}
                        <span className="mdi mdi-plus-circle-outline mr-2"></span>
                        Insertar
                      </button> */}
                    </div>

                    <button
                      onClick={downloadTemplate}
                      type="submit"
                      className={`px-2 py-1 btn btn-info text-dark border-0 rounded ml-1 pr-3`}
                    >
                      <span className="mdi mdi-download mr-2"></span>
                      Plantilla
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          {lecturas && (
            <p className="text-center mt-4 mb-4">
              Última lectura: {convertirFecha(lecturas[0]?.fechaUltimaLectura)}{" "}
              (KWh){" "}
            </p>
          )}
          <DataTableAvantSolar
            data={lecturas}
            dataCopy={lecturasCopy}
            setData={setLecturas}
            titleProps={
              "Listado de Clientes - Huerta: " + obtenerNombreHuertaId(huerta)
            }
            placeholderInput={"Instalación o titular"}
            headers={headers}
            filtros={["numInstalacion", "titular"]}
            headersTable={headersTable}
            name={"listadoClientes"}
            properties={properties}
            defaultMostrar={"Todos"}
            toggleModal={toggleModal}
            loading={loading}
            botonesFiltrado={false}
            inputSearch={true}
            exportButtons={false}
          ></DataTableAvantSolar>
          {error && <Alert message={error} />}
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default ModificarLecturas;
